import styled from 'styled-components';

export const StyledChatButton = styled.button<{ hasUnread: boolean }>`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #ffffff;
  border: none;
  box-shadow: 0 4px 12px rgba(31, 45, 58, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(31, 45, 58, 0.5);
    background: #fafafa;
  }

  &:active {
    transform: scale(0.95);
  }

  &:focus {
    outline: 2px solid #1f2d3a;
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    bottom: 16px;
    right: 16px;
    width: 56px;
    height: 56px;
  }
`;

export const ChatIcon = styled.div`
  font-size: 24px;
  color: #1f2d3a;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UnreadBadge = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ff4d4f;
  color: #fff;
  border-radius: 12px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
`;
